import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const grafanaDashboardPage = PageBlueprint.make({
  name: 'services-overview',
  params: {
    path: '/grafana-overview',
    title: 'Services Overview',
    loader: () =>
      import('./GrafanaDashboardPage').then(m => <m.GrafanaDashboardPage />),
  },
});

const grafanaEntityTab = EntityContentBlueprint.make({
  name: 'dashboard',
  params: {
    path: '/monitoring',
    title: 'Monitoring',
    filter: entity =>
      entity.kind === 'Component' && entity.spec?.type === 'service',
    loader: () =>
      import('./GrafanaEntityDashboard').then(m => (
        <m.GrafanaEntityDashboard />
      )),
  },
});

export const grafanaOverviewModule = createFrontendModule({
  pluginId: 'app',
  extensions: [grafanaDashboardPage, grafanaEntityTab],
});
